<template>
  <div
    :id="controlId"
    class="button-label product-cart-control"
    :class="[
      controlClass,
      {
        cartAdded: isInCart,
        'product-cart-control--text': addLabel,
        'swiper-no-swiping': noSwiping
      }
    ]"
    @mouseleave="$emit('mouseleave')"
  >
    <div class="btn-group d-block newBtn">
      <button
        type="button"
        class="btn btn-sm btn-block add-to-cart-btn"
        :class="[
          addButtonClass,
          {
            bn: language != 'EN',
            'has-cart-quantity': isInCart
          }
        ]"
        @click="$emit('add')"
      >
        <img class="cart-plus-icon" :src="addButtonIcon" />
        <span v-if="addLabel" class="cart-add-label">{{ addLabel }}</span>
        <span v-else class="cart-quantity-badge">
          <span class="amountQuantity">{{ quantity }}</span>
        </span>
      </button>
    </div>
    <div class="btn-group moreBtn">
      <button
        type="button"
        class="btn btn-sm border-right pl-mi"
        @click="$emit('decrement')"
      >
        &#8722;
      </button>
      <button
        type="button"
        class="btn btn-sm border-ab"
        @click="$emit('increment')"
      >
        <span class="amountQuantity">{{ quantity }}</span>&nbsp;
      </button>
      <button
        type="button"
        class="btn btn-sm pl-mi border-left pull-right"
        @click="$emit('increment')"
      >
        &#43;
      </button>
    </div>
  </div>
</template>

<script>
import bagPlusIcon from "@/assets/images/icons/bag-plus.png";
import plusIcon from "@/assets/images/plus-black.png";

export default {
  name: "ProductCartControl",
  props: {
    productId: {
      type: [Number, String],
      required: true
    },
    idPrefix: {
      type: String,
      default: "product_"
    },
    controlClass: {
      type: String,
      default: ""
    },
    addButtonClass: {
      type: String,
      default: ""
    },
    addLabel: {
      type: String,
      default: ""
    },
    language: {
      type: String,
      default: "EN"
    },
    quantity: {
      type: [Number, String],
      default: 0
    },
    inCart: {
      type: Boolean,
      default: false
    },
    noSwiping: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    addButtonIcon() {
      return this.addLabel ? bagPlusIcon : plusIcon;
    },
    isInCart() {
      return this.inCart || Number(this.quantity) > 0;
    },
    controlId() {
      return this.idPrefix + this.productId;
    }
  }
};
</script>

<style scoped>
.product-cart-control {
  position: absolute;
  top: -80px;
  right: 10px;
  z-index: 10000;
  width: 54px;
  min-height: 54px;
  overflow: visible;
}

.product-cart-control.related-cart-control {
  top: auto;
  right: 8px;
  bottom: 8px;
  width: 34px;
  min-height: 34px;
}

.product-cart-control.product-cart-control--text {
  top: auto;
  right: auto;
  z-index: auto;
  width: auto;
  min-height: auto;
}

.product-cart-control .newBtn {
  display: block !important;
  width: 54px;
  margin: 0;
  padding: 0;
  float: none;
  visibility: visible;
}

.product-cart-control.product-cart-control--text .newBtn {
  width: auto;
}

.product-cart-control .add-to-cart-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
  margin: 0;
  border: 1px solid #666665;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 4px #c8c8c8c4;
  font-size: 0 !important;
  line-height: 0;
}

.product-cart-control.product-cart-control--text .add-to-cart-btn {
  width: auto;
  height: auto;
  min-height: 34px;
  padding: 6px 10px;
  border-radius: 3px;
  font-size: 12px !important;
  line-height: 1.2;
}

.product-cart-control .add-to-cart-btn img {
  width: 27px;
  height: auto;
  margin: 0;
  position: static;
}

.product-cart-control.product-cart-control--text .add-to-cart-btn img {
  width: auto;
  max-width: 18px;
  margin-right: 5px;
}

.product-cart-control.related-cart-control .newBtn {
  width: 34px;
}

.product-cart-control.related-cart-control .add-to-cart-btn {
  width: 32px;
  height: 32px;
}

.product-cart-control.related-cart-control .add-to-cart-btn .cart-plus-icon {
  width: 16px;
}

.product-cart-control .cart-quantity-badge {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 4px;
  line-height: 1;
}

.product-cart-control .cart-quantity-badge .amountQuantity {
  color: #000;
  font-size: 16px;
  font-weight: 600;
}

.product-cart-control.cartAdded:not(:hover) .cart-plus-icon {
  display: none;
}

.product-cart-control.cartAdded:not(:hover) .cart-quantity-badge {
  display: flex;
}

.product-cart-control.product-cart-control--text.cartAdded:not(:hover)
  .cart-plus-icon {
  display: inline-block;
}

.product-cart-control.product-cart-control--text.cartAdded > .newBtn {
  display: none !important;
}

.product-cart-control.product-cart-control--text .moreBtn {
  position: static;
  width: auto;
  height: auto;
  margin: 0 6px 5px;
  border-radius: 30px;
  transform: none;
}

.product-cart-control.product-cart-control--text.cartAdded > .moreBtn,
.product-cart-control.product-cart-control--text.cartAdded:hover > .moreBtn,
.product-cart-control.product-cart-control--text.cartAdded:focus-within > .moreBtn {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto;
  transform: none;
}

.product-cart-control.product-cart-control--text .moreBtn .btn {
  display: inline-block;
  height: 33px;
  padding: 5px 10px;
}

.product-cart-control.product-cart-control--text .moreBtn .pl-mi {
  width: auto;
  min-width: 34px;
  font-size: 18px;
  font-weight: 400;
}

.product-cart-control.product-cart-control--text .moreBtn .amountQuantity {
  font-size: 14px;
  font-weight: 500;
}

.product-cart-control .moreBtn {
  position: absolute;
  top: 50%;
  right: 0;
  display: none !important;
  align-items: stretch;
  width: 150px;
  height: 52px;
  margin: 0;
  overflow: hidden;
  border: 1px solid #f89406;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.14);
  pointer-events: none;
  transform: translateY(-50%) scaleX(0.75);
  transform-origin: right center;
  transition: transform 0.18s ease;
}

.product-cart-control.related-cart-control .moreBtn {
  width: 112px;
  height: 34px;
  border-radius: 20px;
}

.product-cart-control.cartAdded .newBtn {
  display: block !important;
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: scale(1);
}

.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.cartAdded
  > .newBtn,
.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.cartAdded:not(:hover)
  > .newBtn {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
  transform: scale(1) !important;
}

.product-cart-control.cartAdded:not(:hover) > .moreBtn {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none;
  transform: translateY(-50%) scaleX(0.75);
}

.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.cartAdded:not(:hover)
  > .moreBtn {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
  transform: translateY(-50%) scaleX(0.75) !important;
}

.product-cart-control.cartAdded:hover > .newBtn,
.product-cart-control.cartAdded:focus-within > .newBtn {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none;
  transform: scale(0.85);
}

.product-cart-control.cartAdded:hover > .newBtn .add-to-cart-btn,
.product-cart-control.cartAdded:focus-within > .newBtn .add-to-cart-btn {
  display: none !important;
}

.product-cart-control.cartAdded:hover > .moreBtn,
.product-cart-control.cartAdded:focus-within > .moreBtn {
  display: flex !important;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto;
  transform: translateY(-50%) scaleX(1);
}

.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.cartAdded:hover
  > .newBtn,
.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.cartAdded:focus-within
  > .newBtn {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
  transform: scale(0.85) !important;
}

.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.cartAdded:hover
  > .moreBtn,
.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.product-cart-control.cartAdded:focus-within
  > .moreBtn {
  display: flex !important;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
  transform: translateY(-50%) scaleX(1) !important;
}

.product-cart-control.product-cart-control--text.cartAdded > .newBtn,
.product-cart-control.product-cart-control--text.cartAdded:hover > .newBtn,
.product-cart-control.product-cart-control--text.cartAdded:focus-within > .newBtn {
  display: none !important;
}

.product-cart-control.product-cart-control--text .moreBtn {
  position: static;
  width: auto;
  height: auto;
  margin: 0 6px 5px;
  transform: none;
}

.product-cart-control.product-cart-control--text.cartAdded > .moreBtn,
.product-cart-control.product-cart-control--text.cartAdded:hover > .moreBtn,
.product-cart-control.product-cart-control--text.cartAdded:focus-within > .moreBtn {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto;
  transform: none;
}

.product-cart-control .moreBtn .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0;
  margin: 0;
  border: 0 !important;
  border-radius: 0;
  background: transparent !important;
  box-shadow: none;
  color: #111111;
  line-height: 1;
  outline: 0 !important;
  -webkit-tap-highlight-color: transparent;
}

.product-cart-control .moreBtn .btn:hover,
.product-cart-control .moreBtn .btn:focus,
.product-cart-control .moreBtn .btn:active,
.product-cart-control .moreBtn .btn:active:focus {
  background: transparent !important;
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
}

.product-cart-control .moreBtn .pl-mi {
  flex: 0 0 48px;
  width: 48px!important;
  font-size: 30px!important;
  font-weight: 700!important;
}

.product-cart-control.related-cart-control .moreBtn .pl-mi {
  flex: 0 0 34px;
  width: 34px;
  font-size: 18px;
}

.product-cart-control .moreBtn .border-ab {
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  gap: 4px;
}

.product-cart-control .moreBtn .pl-mi:first-child {
  border-top-left-radius: 28px;
  border-bottom-left-radius: 28px;
}

.product-cart-control .moreBtn .pl-mi:last-child {
  border-top-right-radius: 28px;
  border-bottom-right-radius: 28px;
  background: transparent !important;
  color: #f89406;
}

.product-cart-control .moreBtn .amountQuantity,
.product-cart-control .moreBtn .inbag {
  color: #000;
  font-size: 25px;
  font-weight: 800;
}

.product-cart-control.related-cart-control .moreBtn .amountQuantity {
  font-size: 14px;
}

@media (hover: none) {
  .product-cart-control.cartAdded .newBtn {
    display: none !important;
    pointer-events: none;
    transform: scale(0.85);
  }

  .product-cart-control.cartAdded .moreBtn {
    display: flex !important;
    pointer-events: auto;
    transform: translateY(-50%) scaleX(1);
  }
}
</style>
